import React, { useEffect } from 'react';
import { Modal, Table, TableColumnsType } from 'antd';
import { formatDate, formatNumber } from '@/utilities/dataUtils';
import { IReceiptLine } from '@/interfaces/receipt';

interface IProps {
  open: boolean;
  invoiceList: IReceiptLine[];
  onClose: () => void;
}

const SellerInvoiceModal: React.FC<IProps> = ({
  invoiceList,
  open,
  onClose,
}) => {
  const handleOk = () => {
    onClose();
  };

  const [invoices, setInvoices] = React.useState<IReceiptLine[]>([]);

  const columns: TableColumnsType<IReceiptLine> = [
    {
      title: '#',
      dataIndex: 'No',
      width: 40,
      align: 'center',
      className: 'text-bold',
      render: (_, rec, i) => {
        if (i !== invoices.length - 1)
          return <div className="font-weight-bold">{i + 1}</div>;
      },
    },
    {
      title: 'เอกสาร INVOICE',
      dataIndex: 'INVOICE_NO',
      align: 'center',
      className: 'text-bold',
      width: 120,
      fixed: 'left',
    },
    {
      title: 'วันที่เอกสาร',
      dataIndex: 'AR_EFFDATE',
      align: 'center',
      className: 'text-bold',
      width: 120,
      render: (_) => formatDate(_),
    },
    {
      title: 'วันที่ครบกำหนด',
      dataIndex: 'AR_DUE_DATE',
      align: 'center',
      className: 'text-bold',
      width: 120,
      render: (_) => formatDate(_),
    },
    {
      title: 'ยอดเงิน',
      dataIndex: 'AR_AMT',
      align: 'right',
      className: 'text-bold',
      width: 120,
      render: (_) => formatNumber(_, 2),
    },
  ];

  useEffect(() => {
    if (invoiceList.length > 0) {
      const summary: Partial<IReceiptLine> = {
        No: '',
        AR_DUE_DATE: 'รวมทั้งหมด',
        AR_AMT: parseFloat(
          invoiceList
            .reduce((sum, invoice) => sum + (invoice.AMT_INV || 0), 0)
            .toFixed(2)
        ),
      };
      setInvoices([...invoiceList, summary as IReceiptLine]);
    } else {
      setInvoices(invoiceList);
    }
  }, [invoiceList]);

  return (
    <Modal
      title="รายละเอียด Invoice"
      open={open}
      onCancel={handleOk}
      footer={false}
      width={800}
    >
      <Table<IReceiptLine>
        columns={columns}
        dataSource={invoices}
        size="small"
        bordered
        rowKey={'INVOICE_NO'}
        pagination={false}
        locale={{
          emptyText: 'ไม่พบรายการ',
        }}
      />
    </Modal>
  );
};

export default SellerInvoiceModal;
